import axios from 'axios'

// Are we running in production?
const { isApiProd, isNodeProd } = environments(process.env.API_ENV, process.env.NODE_ENV)

// Get the base server path
const serverBasePath = basePath(window)

// Determine whether we need to include a port in the URL
const port = getPort(window.location.protocol, window.location.port, isApiProd)

function environments (apiEnv, nodeEnv) {
  return {
    isApiProd: apiEnv === 'prod',
    isNodeProd: nodeEnv === 'production',
  }
}

function basePath (win) {
  const uiPath = win.location.pathname
  const pos = uiPath.lastIndexOf('/client')
  const basePath = uiPath.substr(0, pos + 1)
  return basePath === '' ? '/' : basePath
}

function getPort (protocol, port, isApiProd) {
  // Normal dev environment with json-server
  if (!isApiProd) {
    return ':3004'
  }
  // Production HTTP
  if (protocol === 'http:' && port === '80') {
    return ''
  }
  // Production HTTPS
  if (protocol === 'https:' && port === '443') {
    return ''
  }
  if (port === '') {
    return ''
  }
  return ':' + port
}

// Production API base URL
const { PROD_API_BASE, DEV_API_BASE } = apiPath(window, port, serverBasePath)

function apiPath (win, port, serverBasePath) {
  return {
    PROD_API_BASE: `${win.location.protocol}//${win.location.hostname}${port}${serverBasePath}__api__/`,
    DEV_API_BASE: `${win.location.protocol}//${win.location.hostname}${port}/`,
  }
}

function getServerPath (win, port, serverBasePath, isNodeProd) {
  // Production Server base URL
  // Used for package download requests
  if (isNodeProd) {
    return `${win.location.protocol}//${win.location.hostname}${port}${serverBasePath}`
  }

  // Dev Server base URL. See also /ui/config/index.js for the configuration where we proxy
  // requests to `/SERVER_PATH` to the production server
  return `${win.location.protocol}//${win.location.hostname}${port}/SERVER_PATH/`
}

function pushURL (name, url) {
  if (url !== window.location.pathname + window.location.hash) {
    history.pushState({}, name, url)
  }
}

// Configure Axios
export default axios.create({
  baseURL: isApiProd ? PROD_API_BASE : DEV_API_BASE,
})

export function serverPath () {
  return getServerPath(window, port, serverBasePath, isNodeProd)
}

export function getDevApiBase () {
  return `${window.location.protocol}//${window.location.hostname}${port}`
}

export const helpers = {
  environments,
  basePath,
  getPort,
  apiPath,
  getServerPath,
  pushURL,
}
